define('shoptheme/components/blocks/fce/elements/image-map',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"scrollreveal"
], function(
	$,
	Component,
	BEM,
	ScrollReveal
) {
	return Component.create({

		blocks: null,

		$init: function() {


			this.blocks = BEM.block('image-map');
			this.blocks.each(function() {

				var block = BEM.block(this);
				var list = block.getElements("list");
				var items = block.getElements("list-item");
				var map = block.getElements("map");
				var icons = block.getElements("icon");
				var mobileList = block.getElements("mobile-list");
				var mobileListItem = block.getElements("mobile-list-item");
				var image = block.getElements("image");

				items.click(function(event){
					/*
					if(!$(event.target).is('a')){
						event.preventDefault();
					}
					else {
					}
					*/
					items.removeClass('active');
					$(this).addClass('active');

					var itemIndex = $(this).index();

					mobileListItem.removeClass('active');
					mobileListItem.eq(itemIndex).addClass('active');

				});

				mobileListItem.click(function(event){
					event.preventDefault();
					mobileListItem.removeClass('active');
					$(this).addClass('active');

					var mobileItemIndex = $(this).index();

					items.removeClass('active');
					items.eq(mobileItemIndex).addClass('active');

				});


				/*
				var allItems = list.add(items);
				var reveal = ScrollReveal();

				reveal.reveal(allItems, {
					rotate: {x: 65},
					reset: true,
					opacity: 0,
					mobile: false,
					beforeReset: function (items) {},
					afterReveal: function(items) {}
				}, 100);
				*/


				function mobileHeight() {
					var imageHeight = map.find('img').height();
					mobileList.css('height', imageHeight+'px');
					//console.log(image);
				}

				$(window).resize(function(){
					mobileHeight();
				});

				mobileHeight();

			});

		}

	});
});
